import Vue from "vue";
import { mapMutations } from "vuex";
export default Vue.extend({
  template: `
        <span>
            <button @click="btnClickedHandler()" class="btn-view">view requirements</button>
        </span>
    `,
  methods: {
      btnClickedHandler() {
      this.showModal();
    },
     ...mapMutations([
      'showModal',
    ]),
  },
});